"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.byIds = byIds;

var _immutable = require("immutable");

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var DEFAULT_QUERY = (0, _immutable.fromJS)({
  property: []
});

function byIds(contactIds) {
  (0, _invariant.default)(_immutable.List.isList(contactIds), 'ContactsAPIQuery: expected contactIds to be a List but got %s', contactIds);
  return DEFAULT_QUERY.merge({
    vid: contactIds
  });
}